var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';

  let {
    term,
    content_id,
    term_class,
    popover_class,
    content
  } = options;

__p+='\n\n<span class="'+
((__t=( term_class ))==null?'':__t)+
'"\n      rel="popover-hover"\n      data-container="body"\n      data-placement="bottom"\n      data-popover-content="#'+
((__t=( content_id ))==null?'':__t)+
'">\n  '+
((__t=( term ))==null?'':__t)+
'\n</span>\n<div id="'+
((__t=( content_id ))==null?'':__t)+
'"\n     class="'+
((__t=( popover_class))==null?'':__t)+
' hide">\n  '+
((__t=( content ))==null?'':__t)+
'\n</div>\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/mortgage/popover.jst.ejs